/**
 * SFrame221 — Review Will & Trust (Stream J). Persists to sframe-221.
 */


import { SettlementStepPage } from '../../settlement';
import { SETTLEMENT_PHASE_CONFIGS } from '../../../utils/settlementFlowConfig';



const step = SETTLEMENT_PHASE_CONFIGS.distribute.steps.find((s) => s.id === 'dist-1')!;

export default function SFrame221() {



  const topContent = 
    <div className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 mb-4">
      Use this step to get assets ready for distribution. You don’t need everything finalized before moving forward.
    </div>


  return (
    <SettlementStepPage
      step={step}
      phase="distribute"
      overviewRoute="/sframe-220"
      plannerFrameIds={['frame-246', 'frame-145', 'frame-260']}
      settlementDocumentContext={{ phase: 'distribute', stepId: 'dist-1' }}
      topContent={topContent}
    >
     
    </SettlementStepPage>
  );
}
